module.exports = __webpack_public_path__ + "8fa58b8cebcae9c5c13f7dce170d05be.svg";